import type { ShowtimesFinderFilters, ShowtimesFinderTechnologyFilter } from './ShowtimesFinderFiltersPanel';

const TECHNOLOGY_API_MAP: Record<ShowtimesFinderTechnologyFilter, string> = {
    imax: 'isImax',
    'dolby-atmos': 'isDolbyAtmos',
    'dolby-vision': 'isDolbyVision',
    'dolby-cinema': 'isDolbyCinema',
    '4dx': 'is4DX',
    screenx: 'isScreenX',
    hfr: 'isHFR',
    live: 'isLive',
    dbox: 'isDbox'
};

export function buildApiFilters(filters: ShowtimesFinderFilters): Record<string, string | number | boolean> {
    const result: Record<string, string | number | boolean> = {};

    // Technology (single-select, max 1 item)
    if (filters.technology.length === 1) {
        result[TECHNOLOGY_API_MAP[filters.technology[0]]] = true;
    }

    // Dimension
    if (filters.dimensions.length === 1) {
        result.isThreeDimensional = filters.dimensions[0] === '3d';
    }

    // Language
    const hasOv = filters.languages.includes('ov');
    const hasOmu = filters.languages.includes('omu');
    if (hasOv && hasOmu) {
        result.isOriginalLanguage = true;
    } else if (hasOv) {
        result.isOriginalLanguage = true;
        result.isSubtitled = false;
    } else if (hasOmu) {
        result.isOriginalLanguage = true;
        result.isSubtitled = true;
    }

    // Time (single-select, maps to startTime/endTime hours for hook interpretation)
    if (filters.times.length === 1) {
        const time = filters.times[0];
        if (time === 'lt-18') {
            result.endTime = 18;
        } else if (time === 'gt-18-lt-22') {
            result.startTime = 18;
            result.endTime = 22;
        } else if (time === 'gt-22') {
            result.startTime = 22;
        }
    }

    return result;
}

export function countActiveFilters(filters: ShowtimesFinderFilters): number {
    return filters.times.length + filters.dimensions.length + filters.languages.length + filters.technology.length;
}
